import { ThreadContextItem } from '@varos/assistant-sdk';
import { ChatControllerBaseConfig } from '../base';
import { ComposerController } from './composerInterface';
import { ComposerViewProps } from './composerProps';

export function createComposerController(
    config: ChatControllerBaseConfig
): ComposerController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();

    // Helper function to get display text for context items
    const getDisplayText = (item: ThreadContextItem) => {
        switch (item.kind) {
            case 'solution':
                return `Solution: ${item.solutionId}`;
            case 'collection':
                return `Collection: ${item.collectionId}`;
            default:
                return `Context: ${item.kind}`;
        }
    };

    return {
        useProps(context, props): ComposerViewProps {
            const form = formController.useProps(props.form);
            return {
                submit: {
                    button: {
                        onClick: form.form.handleSubmit(props.form.onSubmit),
                        disabled: !props.field.text.value.trim(),
                    },
                },
                textarea: {
                    value: props.field.text.value,
                    placeholder: props.field.text.placeholder,
                    onChange(event) {
                        props.field.text.onChange(event.target.value);
                    },
                    onKeyDown(event) {
                        if (event.key === 'Enter' && !event.shiftKey) {
                            event.preventDefault();
                            form.form.handleSubmit(props.form.onSubmit)();
                        }
                    },
                },
                option: {
                    popover: {
                        isOpen: props.disclosure.option.isOpen,
                        onOpen: props.disclosure.option.onOpen,
                        onClose: props.disclosure.option.onClose,
                    },
                    form: {
                        onSubmit() {
                            props.disclosure.option.onClose();
                        },
                    },
                },
                context: {
                    selected: props.context.form.value.map((item, index) => ({
                        id: `${item.kind}_${index}`,
                        item: {
                            context: item,
                        },
                        onRemove() {
                            const newItems = (props.context?.form?.value || []).filter(
                                (_, i) => i !== index
                            );
                            props.context?.form?.onChange?.(newItems);
                        },
                    })),
                    popover: {
                        isOpen: props.disclosure.context.isOpen,
                        onOpen: props.disclosure.context.onOpen,
                        onClose: props.disclosure.context.onClose,
                    },
                    form: props.context.form,
                    currentItems: props.context.form.value.map((item, index) => ({
                        id: `${item.kind}_${index}`,
                        display: getDisplayText(item),
                        onRemove: () => {
                            const newItems = (props.context?.form?.value || []).filter(
                                (_, i) => i !== index
                            );
                            props.context?.form?.onChange?.(newItems);
                        },
                    })),
                },
            };
        },
    };
}
